exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.barHolder[data-v-6c2eb852] {\n  width: 100%;\n  height: 4px;\n  border-radius: 999px;\n  overflow: hidden;\n  margin-bottom: 0 !important;\n}\n.barHolder .barFill[data-v-6c2eb852] {\n    border-radius: 999px;\n    background: #00a9f0;\n    height: 100%;\n    transition: all ease-in-out 50ms;\n}\n.barHolder .barFill.paused[data-v-6c2eb852] {\n      background-color: #c5d0de;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6c2eb852","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/notifications/floatingNotifications/timedBar.vue
// module id = 2341
// module chunks = 0